<template>
  <div :class="chipClass">
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  variant: {
    type: String,
    default: "success",
    validator: (value) => ["success", "warning"].includes(value),
  },
});

const chipClass = computed(() => ["chip br-10px", `chip-${props.variant}`]);
</script>

<style lang="scss" scoped>
.chip {
  padding: 6px 12px;
  display: inline-block;
  font-weight: 500;
}

.chip-success {
  color: $color-green;
  background-color: $color-green-3;
}

.chip-warning {
  color: $color-orange-1;
  background-color: $color-secondary;
}
</style>
